import { render, staticRenderFns } from "./AddApk.vue?vue&type=template&id=2ba4db35&"
import script from "./AddApk.vue?vue&type=script&lang=js&"
export * from "./AddApk.vue?vue&type=script&lang=js&"
import style0 from "./AddApk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports